import {
  Identifiable,
  Planzone,
  ResourceDetailsConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): ResourceDetailsConfiguration {
  return [
    {
      name: "Default",
      roles: [
        "pz_admin",
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_manager",
        "pr_worker",
        "pr_visitor",
      ],
      columns: [],
    },
  ];
}

function getResourceDetailsConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.resourceDetailsConfiguration
          ? JSON.parse(data.resourceDetailsConfiguration)
          : getDefaultConf(),
      );
}

export { getResourceDetailsConfiguration };
